<template>
  <section id="contact" class="section">
    <div class="contact-info">
      <h2>Como Nos Encontrar</h2>
      <p>Estamos localizados em Goiatuba, GO e Patrocíonio MG. </p>

      <div class="contact-details">
        
        <p><strong>Telefone:</strong> +55 64996277435</p>
        <p><strong>Email:</strong> solucoescodec@gmail.com </p>
      </div>

      <!-- Formulário com validação -->
      <div class="contact-form">
        <h3>Envie uma mensagem:</h3>
        <form @submit.prevent="sendToWhatsApp">
          <label for="name">Nome:</label>
          <input type="text" id="name" v-model="name" placeholder="Seu nome" />
          <span v-if="errors.name" class="error">{{ errors.name }}</span>

          <label for="email">Email:</label>
          <input type="email" id="email" v-model="email" placeholder="seuemail@exemplo.com" />
          <span v-if="errors.email" class="error">{{ errors.email }}</span>

          <label for="service">Tipo de Serviço:</label>
          <textarea
            id="service"
            v-model="service"
            placeholder="Descreva o tipo de serviço que deseja"
            rows="4"
          ></textarea>
          <span v-if="errors.service" class="error">{{ errors.service }}</span>

          <button type="submit">Enviar para WhatsApp</button>
        </form>
      </div>
    </div>

    <!-- Ícone do WhatsApp -->
    <div class="image-containerwpp">
      <a :href="whatsappLink" target="_blank" rel="noopener noreferrer">
        <img src="@/assets/Images/whatsapp.png" alt="WhatsApp" />
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactPage',
  data() {
    return {
      name: '',
      email: '',
      service: '',
      errors: {},
      phoneNumber: "64996277435", // Número de telefone no formato internacional
      defaultMessage: "Oi! 👋 Vim pelo seu site e quero saber mais sobre a criação de site. Podemos conversar? 🚧🏗️", // Mensagem pré-definida
    };
  },
  computed: {
    // Gera o link do WhatsApp com a mensagem pré-definida
    whatsappLink() {
      return `https://api.whatsapp.com/send?phone=${this.phoneNumber}&text=${encodeURIComponent(this.defaultMessage)}`;
    },
  },
  methods: {
    // Função para validar os campos
    validateForm() {
      this.errors = {};

      if (!this.name) {
        this.errors.name = 'O nome é obrigatório.';
      }
      if (!this.email) {
        this.errors.email = 'O email é obrigatório.';
      } else if (!this.validateEmail(this.email)) {
        this.errors.email = 'Por favor, insira um email válido.';
      }
      if (!this.service) {
        this.errors.service = 'Descreva o tipo de serviço que deseja.';
      }

      return Object.keys(this.errors).length === 0;
    },

    // Função para validar o email
    validateEmail(email) {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailPattern.test(email);
    },

    // Função para gerar o link do WhatsApp com os dados do formulário
    sendToWhatsApp() {
      if (this.validateForm()) {
        const whatsappMessage = `Olá! Meu nome é ${this.name}, meu email é ${this.email}, e gostaria de solicitar o seguinte serviço: ${this.service}`;
        
        // Gerar o link para o WhatsApp
        const message = encodeURIComponent(whatsappMessage);
        const whatsappLink = `https://api.whatsapp.com/send?phone=${this.phoneNumber}&text=${message}`;
        
        // Redireciona automaticamente para o link do WhatsApp
        window.location.href = whatsappLink;
      }
    },
  },
};
</script>

<style scoped>
/* Estilos gerais */
.section {
  padding: 40px;
  background-color: #c4bebe;
  margin: 20px 0;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.contact-info {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

h2 {
  font-size: 2rem; /* Usando unidades relativas */
  margin-bottom: 20px;
}

p {
  font-size: 1.125rem; /* 18px em unidades relativas */
  margin-bottom: 20px;
}

.map-container {
  margin-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;
}

.contact-details p {
  font-size: 1.125rem; /* 18px em unidades relativas */
  margin: 10px 0;
}

.contact-form {
  margin-top: 30px;
}

.contact-form h3 {
  font-size: 1.5rem; /* 24px em unidades relativas */
  margin-bottom: 10px;
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 1rem; /* 16px em unidades relativas */
}

.contact-form button {
  background-color: hsl(231, 76%, 59%);
  color: rgb(211, 206, 206);
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem; /* 16px em unidades relativas */
  transition: background-color 0.3s ease; /* Adicionando transição suave */
}

.contact-form button:hover {
  background-color: #00796b;
}

/* Responsividade */
@media (max-width: 768px) {
  .section {
    padding: 20px;
  }

  .contact-info {
    padding: 15px;
  }

  h2 {
    font-size: 1.75rem; /* 28px em unidades relativas */
  }

  p {
    font-size: 1rem; /* 16px em unidades relativas */
  }

  .map-container {
    height: 200px; /* Ajusta a altura do mapa em telas pequenas */
  }

  .contact-form h3 {
    font-size: 1.25rem; /* 20px em unidades relativas */
  }

  .contact-form input,
  .contact-form textarea {
    font-size: 0.875rem; /* 14px em unidades relativas */
    padding: 8px;
  }

  .contact-form button {
    font-size: 0.875rem; /* 14px em unidades relativas */
    padding: 8px 16px;
  }
}

/* Estilo do WhatsApp fixo na tela */
.image-containerwpp {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.image-containerwpp img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Estilo de erro */
.error {
  color: red;
  font-size: 0.75rem; /* 12px em unidades relativas */
  margin-top: 5px;
}
</style>